import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthenticationService } from "./AuthenticationService";
import { useDistributorStore } from "../store/distributorStore";

/**
* ProtectedRoute
* --------------
* A React Router route wrapper that restricts access to authenticated users.
* - Checks if a valid JWT token exists and is not expired using AuthenticationService.
* - If authenticated, renders child routes via <Outlet />.
* - If not authenticated or token is expired, redirects to `/login`.
* See src/app/DistributorDashboard.tsx for usage.
**/

const isAuthenticated = () => {

  // does token exist?
  const token = AuthenticationService.getToken();
  if (!token) return false;

  // is token expired?
  try {
    const expireFromJWT = AuthenticationService.getPropertyFromJtwToken("exp");
    const expirationTime = expireFromJWT * 1000; // convert to milliseconds
    const currentTime = Date.now();

    return currentTime < expirationTime;
  } catch (error) {
    console.error("Error checking token expiration:", error);
    return false;
  }
};

export const ProtectedRoute: React.FC = () => {
  return isAuthenticated() ? <Outlet /> : <Navigate to="/login" replace />;
};
